(function (global){
(function() {

	'use strict';

	global.jQuery = global.$ = require('jquery');
	require('../../../bower_components/toggles-switches/toggles-switches');

	// require components
	var LanguageSelector = require('../components/language-selector'),
		Picker = require('../components/picker'),
		HeaderScroller = require('../components/header-scroller'),
		HeightMatcher = require('../components/height-matcher'),
		MarketoForm = require('../components/marketo-form'),
		CaseStudySlider = require('../components/case-study-slider'),
		HistorySlider = require('../components/history-slider'),
		LogoWallSlider = require('../components/logo-wall-slider'),
		Counter = require('../components/counter'),
		Parallax = require('../components/parallax'),
		WayPoints = require('../components/waypoints'),
		video = require('../components/video'),
		attachFastClick = require('fastclick'),
		search = require('../components/search'),
		Table = require('../components/table'),
		TableDrawer = require('../components/table-drawer'),
		Accordion = require('../components/accordion'),
		PartnersNav = require('../components/partners-nav');

	// document ready
	$(function() {

		//Ensure javascript re-runs on mobile when hitting back button
		window.onunload = function() {};

		var $parallax = $('[data-parallax]');

		if ($parallax.length) {
			var parallax = new Parallax({
				breakpoint: '1100px'
			});
		}

		// initialize language selector
		var langSelector = new LanguageSelector({
			btn: 'data-lang-btn',
			dropdown: 'data-lang-selector'
		});

		// initialize header scroller
		var headerScroller = new HeaderScroller({
			selector: '[data-header]:not(.header--static)',
			gradientSelector: '[data-header-scroll]',
			fixedOffsetSelector: '[data-header-meta]',
			gradientClass: 'header__gradient--active',
			fixedClass: 'header--fixed'
		});

		// percentage counter
		var attr = 'data-counter',
			dataAttr = '[' + attr + ']',
			$counters = $(dataAttr),
			counters = [];

		$counters.each(function() {
			counters.push(new Counter({
				selector: dataAttr,
				to: $(this).attr(attr)
			}));
		});

		// home page logo wall slider
		var logoWallSlider = new LogoWallSlider({
			selector: '[data-logo-wall-slider]'
		});

		// home page case study slider
		var caseStudySlider = new CaseStudySlider({
			selector: '[data-case-study-slider]'
		});

		// about page history slider
		var historySlider = new HistorySlider({
			sliderSelector: '[data-history-slider]',
			slidesSelector: '[data-history-slide]',
			titlesSelector: '[data-history-title]',
			navClass: 'history-timeline__list'
		});

		// table component
		var table = new Table({
			selector: '[data-table]'
		});

		// accordion component
		var accordion = new Accordion({
			selector: '[data-accordion]'
		});

		// initalize pickers
		var pickers = [];
		$('[data-picker]').each(function() {
			pickers.push(new Picker($(this)));
		});

		// initialize way point fade ins
		var waypoints = new WayPoints();

		var partnersNav = new PartnersNav();

		// remove 300ms delay from clicks / taps
		attachFastClick(document.body);
	});

	$(window).load(function() {
		// initialize height matcher
		var heightMatcherNews = new HeightMatcher({
			selector: '[data-news]'
		});

		var eventsMatcherNews = new HeightMatcher({
			selector: '[data-events]'
		});

		var heightMatcherAwards = new HeightMatcher({
			selector: '[data-awards-large]'
		});

		var calloutsMatcher = new HeightMatcher({
			selector: '[data-callout]'
		});

		var contentCardMatcher = new HeightMatcher({
			selector: '[data-content-card]'
		});

		// initialize marketo forms
		var marketoForm = new MarketoForm();
		marketoForm.renderNewsletter();
		marketoForm.renderDemoRequest();
	});
})();

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
//# sourceMappingURL=data:application/json;charset:utf-8;base64,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